import React, { useContext } from 'react';
import { Accordion as AccordionBoots, Card, AccordionContext, useAccordionButton } from "react-bootstrap";
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';

import { AccordionContainer, AccordionHeader } from './styles';

const ContextAwareToggle = ({ children, eventKey, callback }) => {
  const currentEventKey = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(
    eventKey,
    () => callback && callback(eventKey),
  );

  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <Card.Header onClick={() => decoratedOnClick()}>
      {children}
      {isCurrentEventKey ? <AiOutlineMinus size={14} /> : <AiOutlinePlus size={14} />}
    </Card.Header>
  )
};

const Accordion = ({ header, items }) => {
  return (
    <AccordionContainer>
      {header && (
        <AccordionHeader>
          <p>{header}</p>
        </AccordionHeader>
      )}
      <AccordionBoots>
        {items?.map((card, index) => (
          <Card key={index}>
            <ContextAwareToggle eventKey={index + 1}>
              <span>{index + 1} - {card.title}</span>
            </ContextAwareToggle>
            <AccordionBoots.Collapse eventKey={index + 1}>
              <Card.Body>{card.body}</Card.Body>
            </AccordionBoots.Collapse>
          </Card>
        ))}
      </AccordionBoots>
    </AccordionContainer>
  );
};

export default Accordion;
